import {
  Device,
  DynamicIsland,
  HomeBar,
  Screen,
  StatusBar,
} from "./ios.styles";
import { BatteryGlyph, SignalGlyph, WifiGlyph } from "./iosGlyphs";
import { IosLockScreen } from "./IosLockScreen";
import { IosMessagesScreen } from "./IosMessagesScreen";
import type { PhoneMessage, PhoneScreen } from "../phoneMessage";

export { IOS_PHONE_HEIGHT, IOS_PHONE_WIDTH } from "./ios.styles";

export interface IosPhoneProps {
  message: PhoneMessage;
  screen?: PhoneScreen;
  onRetry?: () => void;
}

export function IosPhone({ message, screen = "app", onRetry }: IosPhoneProps) {
  const locked = screen === "lock";
  return (
    <Device>
      <Screen sx={locked ? { color: "#fff" } : undefined}>
        {locked ? (
          <IosLockScreen message={message} onRetry={onRetry} />
        ) : (
          <IosMessagesScreen message={message} onRetry={onRetry} />
        )}
        <DynamicIsland />
        <StatusBar>
          <span>9:41</span>
          <span>
            <SignalGlyph />
            <WifiGlyph />
            <BatteryGlyph />
          </span>
        </StatusBar>
        <HomeBar />
      </Screen>
    </Device>
  );
}
